/**
 * Created by fers on 19/03/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import DataSourceDecorationEdit from './DataSourceDecorationEdit.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import {displayError} from '../../app/errorDisplayer';
import types from '../../../common/model-api/types';
import urlMapping from '../../app/URLMapping';
import {Link} from 'react-router';
import commonConfig from '../../../common/config';
import FRC from 'formsy-react-components';
const { Checkbox, CheckboxGroup } = FRC;
import {Form} from 'formsy-react';
import LoadingButton from '../../fw/LoadingButton.react';
import config from '../../../common/config';
import {maxTextLength} from '../../fw/Tool';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

export const messages = defineMessages({
    searchAll: {id: 'DataSourceCompanySearchEdit.searchSpecific.title', 'defaultMessage': 'Select specific applications for searching'},
    searchApp: {id: 'DataSourceCompanySearchEdit.searchApp.title', 'defaultMessage': 'Search in:'},
});


class DataSourceCompanySearchEdit extends React.Component {
    static propTypes = {
        apply: PropTypes.func,
        children: PropTypes.any,
        dataSource: PropTypes.object.isRequired,
        goBack: PropTypes.func,
        intl: PropTypes.object,
    };

    constructor(props) {
        super(props);

        let data = safeJSONparse(props.dataSource.args);

        this.state = {
            specificSelection: 'specificSelection' in data ? data.specificSelection : false,
            isLoading: false,
            canSubmit: true,
        };
    }

    onChange = (key, value, payload) => {
        if (value) {
            this.setState({
                specificSelection: true
            });
        } else {
            this.setState({
                specificSelection: false
            });
        }
    };

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    submit = async (data) => {
        this.setState({
            isLoading: true
        });

        let toUpdate = {
            id: this.props.dataSource.id,
        };

        let rules = [];

        /* if we selected channelDefs, prepare match for them */
        if (data.specificSelection) {
            for (let channel of this.props.dataSource.screen.organisation.companySearchAddon.channelAllPlugins) {
                if (data.channels.findIndex((ced) => ced === channel['realId']) !== -1) {

                    let rule = types['entitySelectionRules'].defaultValues(toUpdate);
                    rule['entityDef_id'] = config.ENTITY_DEF_COMPANIES;
                    rule['channel_id'] = channel['realId'];
                    rule['channelDef_id'] = channel['channelDef_id'];

                    rules.push(rule);
                }
            }
        }

        if (rules.length === 0) {
            /* if there is no selected channel in dataSource, we add one 'companySearch' to allow showing of fields of entityDef */
            let rule = types['entitySelectionRules'].defaultValues(toUpdate);
            rule['entityDef_id'] = config.ENTITY_DEF_COMPANIES;
            rule['channelDef_id'] = config.CHANNEL_DEF_COMPANY_SEARCH;

            rules.push(rule);
        }

        toUpdate['args'] = JSON.stringify({specificSelection: data.specificSelection ? data.specificSelection : false});
        toUpdate['entitySelectionRules'] = rules;
        await this.props.apply(toUpdate);

        this.setState({
            isLoading: false
        });
    };

    render() {
        let dataSource = this.props.dataSource;

        let companySearchChannel = dataSource.helperChannels[0];

        try {
            return (
                <DataSourceDecorationEdit
                    dataSource={dataSource}
                    goBack={this.props.goBack}
                >
                    <Form
                        className="DataSourceMatch"
                        onInvalid={this.disableButton}
                        onSubmit={this.submit}
                        onValid={this.enableButton}
                    >
                        <div style={{padding: '2em'}}>
                            {companySearchChannel ? <div className="col-sm-6">

                                <p>
                                    <Link className="btn btn-default" target="_blank" to={commonConfig.PUBLIC_APP_URL + urlMapping.getUrl(types['channels'], 'options', companySearchChannel)}><span className="fa fa-fw fa-cog"/> <FormattedMessage defaultMessage="Configure company search"
                                                                                                                                                                                                                                   id="DataSourceCompanySearchEdit.dataSource.link"/></Link>
                                </p>
                            </div> : null}

                            <div>
                                <Checkbox
                                    label={this.props.intl.formatMessage(messages.searchAll)}
                                    name="specificSelection"
                                    onChange={this.onChange}
                                    value={this.state.specificSelection}
                                />

                                {this.state.specificSelection ?
                                    <CheckboxGroup
                                        disabled={!this.state.specificSelection}
                                        label={this.props.intl.formatMessage(messages.searchApp)}
                                        name="channels"
                                        options={dataSource.screen.organisation.companySearchAddon.channelAllPlugins.map((channel, idx) => {
                                            return ({
                                                value: channel.realId,
                                                label: maxTextLength(channel.name ? channel.name : channel.channelDef.name),
                                                disabled: !this.state.specificSelection
                                            });
                                        })}
                                        required={this.state.specificSelection}
                                        value={dataSource.entitySelectionRules.map((esr) => esr.channel_id)}
                                    />
                                    : null}

                                <LoadingButton
                                    className="btn btn-default"
                                    disabled={!this.state.canSubmit}
                                    isLoading={this.state.isLoading}
                                    type="submit">
                                    <span aria-hidden="true" className="fa fa-edit"></span>{" "}<FormattedMessage defaultMessage="Update" id="DataSourceCompanySearchEdit.updateDataSource" />
                                </LoadingButton>
                            </div>
                        </div>
                    </Form>
                </DataSourceDecorationEdit>
            );
        } catch (e) {
            displayError(e);
            return (<div>Error</div>);
        }
    }
}

export default Relay.createContainer(injectIntl(DataSourceCompanySearchEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    typeId,
                    name,
                    description,
                    args,
                    idx,
                    relativeTo {
                        id,
                        name
                    },
                    helperChannels {
                        id,
                        realId,
                        organisation_id,
                        name,
                    },
                    channelDefs {
                        id,
                        icon,
                        name,
                    },
                    entityDefs {
                        id,
                        name,
                    },
                    entitySelectionRules {
                        id,
                        realId,
                        channel_id,
                        channelDef_id,
                        entityDef_id,
                    },
                    screen {
                        id,
                        realId,
                        organisation {
                            id,
                            realId,
                            name,
                            companySearchAddon {
                                id,
                                type,
                                enabled,
                                options,
                                channelAllPlugins {
                                    name,
                                    type,
                                    channelDef_id,
                                    channelDef {
                                        id,
                                        realId,
                                        icon,
                                        name,
                                        state,
                                        type,
                                    },
                                    id,
                                    realId,
                                    organisation_id,
                                },
                            }
                        }
                    },
                    ${DataSourceDecorationEdit.getFragment('dataSource')}
                }`;
        }
    }
});
